import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { UserEnum, PageType } from '@boels/models';
import { combineLatest, filter, of, switchMap } from 'rxjs';
import { CartFacade } from '../../cart/facade/cart.facade';
import { CmsFacade } from '../../cms/facade/cms.facade';
import { CultureFacade } from '../../cultures/facade/cultures.facade';

export const CheckoutAccountGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const router = inject(Router);
  const cartFacade = inject(CartFacade);
  const cmsFacade = inject(CmsFacade);
  const cultureFacade = inject(CultureFacade);

  return combineLatest([
    cartFacade.getActiveCart(),
    cartFacade.getCartLoading(),
    cultureFacade.getActiveCulture(),
    cartFacade.getCheckoutAccount(),
  ]).pipe(
    filter(([, loading]) => !loading),
    switchMap(([activeCart, , culture, checkoutAccount]) => {
      if (activeCart && activeCart.totalUnitCount) {
        if (checkoutAccount !== UserEnum.ANONYMOUS)
          return of(
            router.createUrlTree([culture, 'checkout', 'customer-details']),
          );

        const url: string = state.url;
        cmsFacade.loadPage(url, PageType.CONTENT_PAGE);

        return of(true);
      }
      return of(router.createUrlTree([culture]));
    }),
  );
};
